import { useState, type ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { FormDialog } from '@/components/dialog/FormDialog';
import { SignaturePad } from '@/components/form/SignaturePad';
import { useSubmit } from '@/hooks/useSubmit';

/**
 * Signature d'une feuille (soumission, validation, signature d'une absence) : la confirmation et la signature dessinée,
 * obligatoire. onSign l'envoie à l'API avec l'image (signTimeSheet) ; réussie, onDone (le dialogue est alors fermé par
 * l'écran), sinon l'erreur de l'API s'affiche et le dialogue reste ouvert.
 */
export function SignDialog({
  title,
  description,
  confirmLabel,
  confirmIcon,
  onSign,
  onDone,
  onClose,
}: {
  title: ReactNode;
  description: ReactNode;
  confirmLabel: string;
  confirmIcon: LucideIcon;
  onSign: (image: Blob) => Promise<unknown>;
  onDone: () => void;
  onClose: () => void;
}) {
  const [image, setImage] = useState<Blob | null>(null);
  const { submit, submitting, error } = useSubmit();

  return (
    <FormDialog
      title={title}
      description={description}
      submitLabel={confirmLabel}
      submitIcon={confirmIcon}
      canSubmit={!!image}
      submitting={submitting}
      error={error}
      onSubmit={() =>
        submit(async () => {
          await onSign(image!);
          onDone();
        })
      }
      onClose={onClose}
    >
      <SignaturePad id="signature" onChange={setImage} />
    </FormDialog>
  );
}
